import { render, staticRenderFns } from "./HandoverCustomers.vue?vue&type=template&id=4226305a&scoped=true"
import script from "./HandoverCustomers.vue?vue&type=script&lang=js"
export * from "./HandoverCustomers.vue?vue&type=script&lang=js"
import style0 from "./HandoverCustomers.vue?vue&type=style&index=0&id=4226305a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4226305a",
  null
  
)

export default component.exports